function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10S0 15.522 0 10 4.477 0 10 0z",
  fill: "#7EC500"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.81 5H4.19c-.105 0-.19.09-.19.2v9.6c0 .11.085.2.19.2h11.62c.105 0 .19-.09.19-.2V5.2c0-.11-.085-.2-.19-.2zM15 13l-2.69-2.784a.08.08 0 00-.111-.005l-1.866 1.642-2.385-2.935a.08.08 0 00-.126.003L5 12.703V6h10v7z",
  fill: "#FFF"
}))));